import { FunctionComponent } from 'react';
import { StyledButton } from './Button.styled';
import { ButtonProps } from './types';

export const Button: FunctionComponent<ButtonProps> = props => {
  const { children, ...rest } = props;

  return <StyledButton {...rest}>{children || '\u200c'}</StyledButton>;
};
